import _ from "lodash";
import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const get = async (url, params) => {
  try {
    const sessionKey = localStorage.getItem("session_key");

    const res = await axios({
      method: "get",
      url: API_ENDPOINT + url,
      headers: {
        Authorization: `Bearer ${sessionKey}`,
      },
      params,
    });

    // console.log(res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const post = async (
  url,
  data,
  type = "application/x-www-form-urlencoded"
) => {
  try {
    const sessionKey = localStorage.getItem("session_key");

    const res = await axios({
      method: "post",
      url: API_ENDPOINT + url,
      data,
      headers: {
        Authorization: `Bearer ${sessionKey}`,
        "Content-Type": type,
      },
    });

    // console.log(res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};
